import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {
  BokkzClient,
  ClientEntity,
  BezwaarEntity, BokkzBezwaarDataService, BokkzBezwaarClient, BokkzAlgDataService
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ActivatedRoute} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {ToastService} from "@snelstart/ui-toast";
import { SharedUiTableModule, TableConfiguration, ZeroStateConfiguration } from '@snelstart/ui-table';
import {SearchCriteria, SearchResult} from "@snelstart/domain-logic";
import {Observable, switchMap} from "rxjs";
import { SharedUiIconModule } from '@snelstart/ui-icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-bezwaar-list',
  templateUrl: './feature-tax-bezwaar-list.component.html',
  styleUrl: './feature-tax-bezwaar-list.component.scss',
  imports: [
    SharedUiIconModule,
    SharedUiTableModule,
    CommonModule
  ]
})
export class FeatureTaxBezwaarListComponent implements OnInit {

  @Output() public details = new EventEmitter<any>();
  protected clientId: any;
  public clientEntity = {} as ClientEntity;
  public dialogVisible = false;

  constructor(
    public dataService: BokkzBezwaarDataService,
    public bezwaarClient: BokkzBezwaarClient,
    public algDataService: BokkzAlgDataService,
    public bokkzClient: BokkzClient,
    public toastService: ToastService,
    public fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.clientId = params['clientId'];
      this.bokkzClient.getClient(this.clientId).subscribe((value) => {
        this.algDataService.updateClient(value);
        this.clientEntity = value;
      })
    });
  }

  public tableConfig = TableConfiguration.create<SearchCriteria, BezwaarEntity>({
    identifier: 'id',
    options: {
      useSearch: false,
      useSort: true,
    },
    criteria: {take: 6, skip: 2, sortDescending: false} as SearchCriteria,
    search: () => {
      const list = this.bezwaarClient.getAllBezwaren(this.clientId);
      return list.pipe(
        switchMap((list) => {
          const result = list;
          this.dataService.updateList(list)
          return new Observable<SearchResult<BezwaarEntity>>((subscriber) => {
            subscriber.next(new SearchResult(result, result.length));
            subscriber.complete();
          });
        }),
      );
    },
    details: (entity) => {
      if (entity != undefined) {
        this.dataService.updateItem(entity);
        this.details.next(entity.id);
      }
    },
    zeroStateConfig: ZeroStateConfiguration.create({
      icon: 'book-open-cover',
      mainText: $localize`Geen bezwaarschriften aanwezig`,
      subText: 'Klik op  \' + Nieuw bezwaar\' voor het aanmaken van een bezwaarschrift.',
    }),
  });
}
